module.exports = __webpack_public_path__ + "media/PAG72-02.015b42cd.mp3";